import { roundToTen } from "src/util";
import { IChartPoint } from "../../types";

export const createChartPoint = (
  coachAverage: number,
  studentAverage: number,
  date: string,
  sportId: number
): IChartPoint => ({
  coach: parseFloat(roundToTen(coachAverage)),
  date,
  sportId,
  student: parseFloat(roundToTen(studentAverage)),
});



// WEBPACK FOOTER //
// ./src/features/director/pages/SurveyDataCenter/hooks/utils/createChartPoint/createChartPoint.ts